<stusan-control-button *ngIf="showZwiftShareButton$ | async"
                       class="zwift-share-button"
                       [ariaLabel]="(this.stateService.isZwiftShareEnabled$ | async) ? 'Stop zwift sharing' : 'Start zwift sharing'"
                       [tooltipText]="(this.stateService.isZwiftShareEnabled$ | async) ? 'Stop zwift sharing' : 'Start zwift sharing'"
                       (click)="toggleShareScreen()">
  <stusan-toggle-icon
    [label]="'Zwift'"
    [icon]="'menu-zwift'"
    [state]="this.isZwiftShareClicked">
  </stusan-toggle-icon>
</stusan-control-button>
